/**
 * Format a numeric price for display.
 * @param {number} price
 * @param {string} [currency='EGP']
 * @returns {string}  e.g. "3,500 EGP"
 */
export function formatPrice(price, currency = 'EGP') {
  const formatted = new Intl.NumberFormat('en-EG', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(price)
  return `${formatted} ${currency}`
}

/**
 * Compact format for large prices (e.g. "3.5K EGP").
 */
export function formatPriceCompact(price, currency = 'EGP') {
  if (price >= 1000) {
    return `${(price / 1000).toFixed(1).replace('.0', '')}K ${currency}`
  }
  return formatPrice(price, currency)
}
